import { EventBodyParser } from './models';

const eventsBodyParser = ({ sortBy, hitsPerPage, from, pageId }: EventBodyParser) => {
  const mustQueries: any = [];

  if (pageId) {
    mustQueries.push({
      term: {
        landingPageId: pageId,
      },
    });
  }

  if (sortBy === `${process.env.GATSBY_ELASTIC_INDEX}-events`) {
    mustQueries.push({
      range: {
        'events.startDate': {
          gt: 'now',
        },
      },
    });
  }

  return {
    query: mustQueries.length > 0 ? { bool: { must: mustQueries } } : { match_all: {} },
    size: hitsPerPage,
    from: from || 0,
    ...(sortBy && {
      sort: [{ 'events.startDate': { order: 'desc' } }],
    }),
  };
};

export default eventsBodyParser;
